import Component from 'flarum/common/Component';

// Decorative studio surface. The affine grid follows the aluminium housing's
// perspective; gradients keep the edges open to the native page background.
const traces = ['M-170 180H-115L-95 200H20', 'M300 30H250L224 56V135L202 157H177', 'M332 172H268L246 150V126L224 104H205'];
export default class HeroStage extends Component {
  view() {
    return m("div", {
      className: "BsiHeroStage",
      "aria-hidden": "true"
    }, m("div", {
      className: "BsiHeroStage-light"
    }), m("svg", {
      className: "BsiHeroStage-surface",
      viewBox: "0 0 600 480",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      focusable: "false"
    }, m("defs", null, m("radialGradient", {
      id: "bsi-stage-fade"
    }, m("stop", {
      offset: "0",
      "stop-color": "white"
    }), m("stop", {
      offset: ".55",
      "stop-color": "white",
      "stop-opacity": ".85"
    }), m("stop", {
      offset: "1",
      "stop-color": "white",
      "stop-opacity": "0"
    })), m("radialGradient", {
      id: "bsi-stage-floor"
    }, m("stop", {
      offset: "0",
      "stop-color": "var(--bsi-stage-floor)",
      "stop-opacity": ".2"
    }), m("stop", {
      offset: ".6",
      "stop-color": "var(--bsi-stage-floor)",
      "stop-opacity": ".07"
    }), m("stop", {
      offset: "1",
      "stop-color": "var(--bsi-stage-floor)",
      "stop-opacity": "0"
    })), m("radialGradient", {
      id: "bsi-stage-shadow"
    }, m("stop", {
      offset: "0",
      "stop-color": "var(--bsi-stage-shadow)",
      "stop-opacity": ".24"
    }), m("stop", {
      offset: ".4",
      "stop-color": "var(--bsi-stage-shadow)",
      "stop-opacity": ".13"
    }), m("stop", {
      offset: "1",
      "stop-color": "var(--bsi-stage-shadow)",
      "stop-opacity": "0"
    })), m("mask", {
      id: "bsi-stage-mask",
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "600",
      height: "480"
    }, m("ellipse", {
      cx: "310",
      cy: "258",
      rx: "298",
      ry: "208",
      fill: "url(#bsi-stage-fade)"
    })), m("pattern", {
      id: "bsi-stage-grid",
      width: "38",
      height: "38",
      patternUnits: "userSpaceOnUse"
    }, m("path", {
      d: "M38 0H0V38",
      className: "BsiHeroStage-grid"
    }))), m("ellipse", {
      cx: "314",
      cy: "296",
      rx: "286",
      ry: "161",
      fill: "url(#bsi-stage-floor)"
    }), m("g", {
      mask: "url(#bsi-stage-mask)"
    }, m("g", {
      transform: "matrix(1 .28 -.82 .72 300 156)"
    }, m("rect", {
      x: "-400",
      y: "-260",
      width: "800",
      height: "720",
      fill: "url(#bsi-stage-grid)"
    }), m("g", {
      className: "BsiHeroStage-traces"
    }, traces.map((path, index) => m("path", {
      key: index,
      d: path
    })), m("circle", {
      cx: "-170",
      cy: "180",
      r: "4"
    }), m("circle", {
      cx: "300",
      cy: "30",
      r: "4"
    }), m("circle", {
      cx: "332",
      cy: "172",
      r: "4"
    })), m("path", {
      className: "BsiHeroStage-pulse",
      d: traces[0],
      pathLength: "100"
    }), m("g", {
      className: "BsiHeroStage-marks"
    }, m("path", {
      d: "M-150 116H-138M-144 110V122M274-47H286M280-53V-41M140 272H152M146 266V278"
    })))), m("g", {
      className: "BsiHeroStage-shadow"
    }, m("ellipse", {
      cx: "310",
      cy: "310",
      rx: "217",
      ry: "68",
      transform: "rotate(12 310 310)",
      fill: "url(#bsi-stage-shadow)"
    }), m("ellipse", {
      cx: "315",
      cy: "316",
      rx: "152",
      ry: "32",
      transform: "rotate(12 315 316)",
      fill: "url(#bsi-stage-shadow)"
    }))));
  }
}
flarum.reg.add('bsi-orders', 'forum/components/HeroStage', HeroStage);